import { SelectContainer } from './SelectContainer';
import { Control } from './Control';
import { IndicatorSeparator } from './IndicatorSeparator';
import { Placeholder } from './Placeholder';
import { SingleValue } from './SingleValue';
import { ValueContainer } from './ValueContainer';
import { DropdownIndicator } from './DropdownIndicator';
import { IndicatorsContainer } from './IndicatorsContainer';
import { Input } from './Input';
import { Menu } from './Menu';
import { Option } from './Option';
import { MenuList } from './MenuList';
import { Group } from './Group';
import { LoadingIndicator } from './LoadingIndicator';
import { LoadingMessage } from './LoadingMessage';
import { NoOptionsMessage } from './NoOptionsMessage';
import { MultiValue } from './MultiValue';
import { ClearIndicator } from './ClearIndicator';

export const components = {
  SelectContainer,
  Control,
  IndicatorSeparator,
  Placeholder,
  SingleValue,
  ValueContainer,
  DropdownIndicator,
  IndicatorsContainer,
  Input,
  MenuList,
  ClearIndicator,
  MultiValue,
  NoOptionsMessage,
  LoadingMessage,
  LoadingIndicator,
  Group,
  Option,
  Menu,
};
